/* eslint-disable no-underscore-dangle */
import { API_EVENTS, REMOVE_MEDIA_EVENTS } from '../constants/actionTypes';

export const initialState = {
  loading: false,
  data: null,
  error: null,
};

const contractTermsReducer = (state, { type, payload }) => {
  switch (type) {
    case API_EVENTS.REQUEST:
      return { ...state, loading: true };

    case API_EVENTS.SUCCESS: {
      return { ...state, loading: false, data: payload };
    }

    case API_EVENTS.FAIL:
      return { ...state, loading: false, error: payload };

    case API_EVENTS.RESET:
      return initialState;

    case REMOVE_MEDIA_EVENTS.REMOVE_SUCCESS:
      return { ...state, loading: false, data: { ...state.data, contract: undefined } };

    case 'DELETE_CONTRACT_TERM':
      return {
        ...state,
        loading: false,
        data: { ...state.data, term: state.data.term.filter((x) => x.value !== payload) },
      };

    default:
      return state;
  }
};

export default contractTermsReducer;
